import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";

import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";

import ListItemText from "@mui/material/ListItemText";

import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router";
import logoImg from "../../assets/images/logo.png";


const trendMenu = [
  { id: 0, title: "Home", section_id: "/" },
  { id: 1, title: "About", section_id: "About" },
  { id: 2, title: "TREND Team", section_id: "TREND Team" },
  { id: 3, title: "TREND Themes", section_id: "TREND Themes" },
  { id: 4, title: "TREND News", section_id: "TREND News" },
  { id: 5, title: "TREND Treats", section_id: "TREND Treats" },
  { id: 6, title: "Contact Us", section_id: "Contact Us" },
];

export const TrendHamburger = () => {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };
  const handleListItemClick = (section_id) => {
    if (section_id === "/") {
      navigate("/"); // Navigate to home route
    } else {
      const element = document.getElementById(section_id);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 300); // Delay to allow drawer to close
      } else {
        console.error("Element not found for section: ", section_id);
      }
    }
  };

  const DrawerList = (
    
    <Box
      sx={{ backgroundColor: "#001728", width: 250, height: "100%" }}
      role="presentation"
      onClick={toggleDrawer(false)}
    >
      <List className="text-white">
        {trendMenu.map((text, index) => (
          <ListItem key={text.id} disablePadding>
            <ListItemButton
              onClick={() => handleListItemClick(text.section_id)}
            >
              <ListItemText primary={text.title} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <div className="flex flex-row justify-between">
      <div
        className="flex flex-col items-center text-center text-white text-sm md:text-2xl mt-2 ml-3 cursor-pointer"
        style={{ fontFamily: "Montserrat" }}
        onClick={() => navigate("/")}
      >
        <img src={logoImg} alt="logo" className="w-24" />
        JAWAID LAB
      </div>
      <Button onClick={toggleDrawer(true)}>
        <MenuIcon sx={{ color: "#37A4A5" }} />
      </Button>
      <Drawer open={open} onClose={toggleDrawer(false)}>
        {DrawerList}
      </Drawer>
    </div>
  );
};
